"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BloxAlert: true,
  BloxBreadcrumb: true,
  BloxBreadcrumbItem: true,
  BloxConnectSocialButton: true,
  BloxDialog: true,
  BloxDialogAction: true,
  BloxSearch: true,
  BloxSelect: true,
  BloxSingleValue: true,
  BloxStatus: true,
  BloxSwitch: true,
  BloxTab: true,
  BloxTabGroup: true,
  BloxTabPanel: true,
  BloxTooltip: true
};
exports.BloxTooltip = exports.BloxTabPanel = exports.BloxTabGroup = exports.BloxTab = exports.BloxSwitch = exports.BloxStatus = exports.BloxSingleValue = exports.BloxSelect = exports.BloxSearch = exports.BloxDialogAction = exports.BloxDialog = exports.BloxConnectSocialButton = exports.BloxBreadcrumbItem = exports.BloxBreadcrumb = exports.BloxAlert = void 0;

var _generateEl = require("./generateEl");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _native = require("./native");

Object.keys(_native).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _native[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _native[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BloxAlert = (0, _generateEl.generateEl)('blox-alert', 'BloxAlert', ['action-primary', 'action-secondary']);
exports.BloxAlert = BloxAlert;
var BloxBreadcrumb = (0, _generateEl.generateEl)('blox-breadcrumb', 'BloxBreadcrumb');
exports.BloxBreadcrumb = BloxBreadcrumb;
var BloxBreadcrumbItem = (0, _generateEl.generateEl)('blox-breadcrumb-item', 'BloxBreadcrumbItem');
exports.BloxBreadcrumbItem = BloxBreadcrumbItem;
var BloxConnectSocialButton = (0, _generateEl.generateEl)('blox-connect-social-button', 'BloxConnectSocialButton');
exports.BloxConnectSocialButton = BloxConnectSocialButton;
var BloxDialog = (0, _generateEl.generateEl)('blox-dialog', 'BloxDialog', ['close']);
exports.BloxDialog = BloxDialog;
var BloxDialogAction = (0, _generateEl.generateEl)('blox-dialog-action', 'BloxDialogAction', ['click']);
exports.BloxDialogAction = BloxDialogAction;
var BloxSearch = (0, _generateEl.generateEl)('blox-search', 'BloxSearch', ['clear', 'search-enter', 'search-keystroke']);
exports.BloxSearch = BloxSearch;
var BloxSelect = (0, _generateEl.generateEl)('blox-select', 'BloxSelect', ['blox-change', 'blox-input', 'blox-options-hidden', 'blox-options-visible', 'selection', 'multiple-selection']);
exports.BloxSelect = BloxSelect;
var BloxSingleValue = (0, _generateEl.generateEl)('blox-single-value', 'BloxSingleValue');
exports.BloxSingleValue = BloxSingleValue;
var BloxStatus = (0, _generateEl.generateEl)('blox-status', 'BloxStatus', ['close']);
exports.BloxStatus = BloxStatus;
var BloxSwitch = (0, _generateEl.generateEl)('blox-switch', 'BloxSwitch', ['toggle']);
exports.BloxSwitch = BloxSwitch;
var BloxTab = (0, _generateEl.generateEl)('blox-tab', 'BloxTab', ['select']);
exports.BloxTab = BloxTab;
var BloxTabGroup = (0, _generateEl.generateEl)('blox-tab-group', 'BloxTabGroup', ['tab-select']);
exports.BloxTabGroup = BloxTabGroup;
var BloxTabPanel = (0, _generateEl.generateEl)('blox-tab-panel', 'BloxTabPanel');
exports.BloxTabPanel = BloxTabPanel;
var BloxTooltipBase = (0, _generateEl.generateEl)('blox-tooltip', 'BloxTooltip');
var BloxTooltip = (0, _styledComponents["default"])(BloxTooltipBase).withConfig({
  displayName: "blox__BloxTooltip",
  componentId: "sc-v62dp9-0"
})(["white-space:normal;font-weight:var(--blox-font-weight);"]);
exports.BloxTooltip = BloxTooltip;